import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import Getintouch from '../layouts/Getintouch'
import FAQSection from '../layouts/FAQSection'
import Map from '../layouts/Map'

const Contact = () => {
    return (
        <div>
            <Header />
            <section className="stats-section">
                <div className="container">
                    {/* Left Text */}
                    <div className="left">
                        <h1>Contact us</h1>
                        <p>
                            Great projects start with a conversation — let Code Buddy’s turn your ideas into powerful digital
                            solutions.
                        </p>
                        <div className="contact-icons">
                            <a href="https://wa.link/79e13j" target="_blank" rel="noopener noreferrer">
                                <img src={process.env.PUBLIC_URL + "/images/con-icon1.png"} alt="WhatsApp" />
                            </a>
                            <a href="https://teams.microsoft.com/l/chat/0/0?users=doshiabhi420@gmail.com" target="_blank" rel="noopener noreferrer">
                                <img src={process.env.PUBLIC_URL + "/images/con-2.png"} alt="Skype" />
                            </a>
                            <a href="https://www.upwork.com/freelancers/~01db9a28dfd468e8e9?mp_source=share" target="_blank" rel="noopener noreferrer">
                                <img src={process.env.PUBLIC_URL + "/images/con-icon3.png"} alt="Upwork" />
                            </a>
                            <a href="https://clutch.co/profile/code-buddys" target="_blank" rel="noopener noreferrer">
                                <img src={process.env.PUBLIC_URL + "/images/con-icon4.png"} alt="CodeBuddy" />
                            </a>
                        </div>
                    </div>

                    {/* Right Cards */}
                    <div className="right">
                        <div className="card card1">
                            <img src={process.env.PUBLIC_URL + "/images/contact-1.png"} alt="Inquiries" />
                            <div className="info">
                                <h2>Inquiries</h2>
                                <p>Get in touch</p>
                            </div>
                        </div>
                        <div className="card card2">
                            <img src={process.env.PUBLIC_URL + "/images/contact-2.png"} alt="Projects" />
                            <div className="info">
                                <h2>Projects</h2>
                                <p>Get in touch</p>
                            </div>
                        </div>
                        <div className="card card3">
                            <img src={process.env.PUBLIC_URL + "/images/contact-3.png"} alt="Careers" />
                            <div className="info">
                                <h2>Careers</h2>
                                <p>Get in touch</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>t,gXN@rCtg6Wk,2#DQ
            <Getintouch />
            <FAQSection/>
             <Map/>
            <Footer />
        </div>
    )
}

export default Contact